import React, { useEffect, useRef } from 'react';
import './popupcontainer.scss';
export default function PopUpContainer({ children }) {
  const ele = useRef(null);
  useEffect(() => {
    const appHeight = () => {
      const doc = ele?.current;
      if (doc) doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    };
    window.addEventListener('resize', appHeight);
    appHeight();
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div ref={ele} className="popup-container">
      {children}
    </div>
  );
}
